
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-slate-800 text-white py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              İletişim
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Sorularınız için bizimle iletişime geçin. Uzman ekibimiz size yardımcı olmaktan mutluluk duyar.
            </p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-2xl text-orange-500"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">Telefon</h3>
                <p className="text-gray-600">+90 532 550 35 42</p>
              </div>
              
              <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-2xl text-orange-500"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">E-posta</h3>
                <p className="text-gray-600">nbacivata@gmail.com</p>
              </div>
              
              <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-2xl text-orange-500"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-2">Adres</h3>
                <p className="text-gray-600">
                  Bağlarbaşı Mahallesi Cemalbey Caddesi<br />
                  Irmak Sokak 13/6<br />
                  Maltepe/İstanbul
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}